import React from 'react';
import { DialogTrigger } from 'react-aria-components';

type ModalRootProps = {
  /** The children to render inside the component. Should be `Modal.Content`. */
  children: React.ReactNode;
};

/**
 * A trigger container that listens for a button press to open the modal dialog. It should wrap around a `design-system` `Button` and `Modal.Root`.
 * **Should only be used when the `ModalDialog`'s open state is uncontrolled**
 */
export const ModalDialogTrigger = ({ children }: ModalRootProps) => {
  return <DialogTrigger>{children}</DialogTrigger>;
};
